module.exports = __webpack_public_path__ + "img/home-delivery_small@2x.f6d9b006.webp";